import { Suspense, lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { LayoutSplashScreen } from "../../../_metronic";

const AdminUserPage = lazy(() => import("./admin-user/AdminUserPage"));
const AdminGroupPage = lazy(() => import("./admin-group/AdminGroupPage"));
const DashboardPage = lazy(() => import("./dashboard/DashboardPage"));
const ContentPage = lazy(() => import("./content/ContentPage"));
const Badge = lazy(() => import("./settings/badge/BadgePage"));
const GalleriaTag = lazy(() => import("./settings/galleria-tag/GalleriaTagPage"));
const Benefit = lazy(() => import("./benefit/BenefitPage"));
const Event = lazy(() => import("./event/EventPage"));
const Member = lazy(() => import("./member/MemberPage"));
const Post = lazy(() => import("./post/PostPage"));

export default function HomePage() {
    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <Switch>
                <Redirect exact from="/" to="/dashboard" />

                <Route path="/dashboard" component={DashboardPage} />
                <Route path="/content" component={ContentPage} />
                <Route path="/badge" component={Badge} />
                <Route path="/galleria-tag" component={GalleriaTag} />
                <Route path="/benefit" component={Benefit} />
                <Route path="/member" component={Member} />
                <Route path="/event" component={Event} />
                <Route path="/post" component={Post} />
                <Route path="/admin-user" component={AdminUserPage} />
                <Route path="/admin-group" component={AdminGroupPage} />

                <Redirect to="/error/error-v6" />
            </Switch>
        </Suspense>
    );
}
